import moment from "moment-timezone";
import { formatDate, parseStringServerDate, parseStringServerDateWithTimezone } from "./dateUtils";
import { SilencingStatus } from "Consts";

export const getSilencingStatus = (row, groupedByServer) => {
  const serverName = row.serverName;
  const silencedForServer = groupedByServer[serverName] || [];
  const nowUTC = moment.utc();

  let activeSilencingWindows = [];
  let silencingStatus: any = SilencingStatus.None; // initial> No silencing windows scheduled
  if (silencedForServer.length > 0) {
    activeSilencingWindows = silencedForServer.filter((s) => {
      const swStart = parseStringServerDateWithTimezone(s.startTime, s.serverTimeZone);
      const swEnd = parseStringServerDateWithTimezone(s.endTime, s.serverTimeZone);
      //@ts-ignore
      // return swStart <= nowUTC && nowUTC < swEnd;
      return swStart.isSameOrBefore(nowUTC) && nowUTC.isBefore(swEnd);
    });

    if (activeSilencingWindows.length > 0) {
      silencingStatus = SilencingStatus.Active;
    } else {
      silencingStatus = SilencingStatus.Future;
    }
  }
  return silencingStatus;
};

export const getHealthAsString = (downSinceDateTime, currentUser) => {
  if (downSinceDateTime) {
    //@ts-ignore
    const ms = getNow(currentUser).diff(parseStringServerDate(downSinceDateTime));
    const duration = moment.duration(ms);
    return `Started: ${formatDate(
      downSinceDateTime,
      currentUser
    )}. Duration: ${duration.humanize()} Down`;
  }
  return "Healthy";
};
